import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
// ====================================================================
// ziven-theme-aura v0.2.7 modifyDiscussionHero.js
// ====================================================================
//
// 移动端 DiscussionPage hero 改设计 (辉哥 2026-09-16 10:41 拍板 v6 设计图):
//   - Hero 标题 (.DiscussionHero-title) 从 hero 完全移除 → 移到 Post-main 里
//     Post-header 上面 (.PostHeroTitle, amber 左边框卡片)
//     (辉哥 9/17 09:43 拍板: 标题移到最上面, header 跟用户信息在下面)
//     (改前 r.16: 标题在 Post-header 下面; 改后 r.17: 标题在 Post-header 上面)
//   - 关注按钮: vendor flarum/follow-users 扩展 (UserCard.prototype.view splice,
//     bjxy.top/d/12 当前未登录态 hero 无此 DOM, 登录态也不会渲染到 hero — 关注
//     按钮只渲染在 UserCard). r.16 在 Post-main 第一个 Post 的 .Post-header 行
//     右侧**新建**一个关注按钮 (用 ianm/follow-users 的 follow API:
//     user.save({ followUsers: 1 }))
//   - 桌面端 (@media (min-width: 992px)) 完全不动 — 标题仍在 hero, 关注按钮
//     不渲染 (走 ianm/follow-users UserCard 流程)
//
// v6 vs v5 区别:
//   - v5: 关注按钮留在 hero 顶部 — 错了 (跟 Post-header 不在同一行, 视觉分散)
//   - v6: 关注按钮移到 Post-header 行右侧 (跟用户名+头像+时间 同一行,
//     flex 布局 flex:1 推按钮到右)
//
// CSS 配合: less/forum.less 19 段
//   - .DiscussionHero-title { display: none !important } (移动端)
//   - .DiscussionHero [class*="FollowUser"] { display: none } (兜底)
//   - .PostStream .Post:first-child .Post-header > ul { display: flex } (移动端)
//   - .PostStream .Post:first-child .PostHeroTitle { amber 左边框 } (移动端)
//
// 检测移动端: window.matchMedia('(max-width: 991.98px)'), 跟 less @media 一致.
//
// r.19 / r.19.1 / r.19.2 (辉哥 9/17 10:38 / 10:48 / 9/18 10:55 拍板) 改设计:
//   - 把 .DiscussionHero-title + .DiscussionHero .item-tags 从 hero 搬走
//   - r.19: 新加 moveTagsToPostMain() 搬 tags (moveTitleToPostMain 之前就有)
//   - r.19.1: mithril race workaround, 用 CSS order 强制视觉 [Title, Tags, Header]
//     (注: 实际 DOM 顺序是 [Tags, Title, Header], CSS order 不受 mithril revert 影响)
//   - r.19.2: 修 r.19.1 CSS order 副作用 — .Post-main flex column 把 .Post-actions/.Post-footer
//     顶出 vendor 默认横排布局, 撤掉 CSS order 让 vendor 默认 (float right + inline-block) 生效
//   - 旧监听对象: DiscussionHero.prototype.oncreate/onupdate
//
// r.19.3 (辉哥 9/18 12:21 拍板) 修 ziven-core r.18x 副作用 (返工):
//   - 真因: ziven-core r.18x (commit 0b0ed97) 让 hero() 在 heroImageUrl 不存在时返 null →
//     vendor DiscussionHero 整个不渲染 → 旧 DiscussionHero.oncreate 监听失效 →
//     Post-main 内没 PostHeroTitle / PostHeroTags → 标题/tags 都丢 (辉哥 9/18 11:19 d/13 反馈)
//   - 修法 (临场优化):
//     1. 取消旧 DiscussionHero 监听 (4 行) — r.18x 后:
//        - 无图情况: DiscussionHero 不渲染, 旧监听失效 (新监听兜底)
//        - 有图情况: ziven-core DiscussionPageHero 内部含 vendor DiscussionHero, 旧监听会搬
//          .DiscussionHero-title + .item-tags, 但同时新监听从 this.discussion 构造会重复 →
//          Post-main 出现 2 个 PostHeroTitle + PostHeroTags (实测 bug)
//        修法: 取消旧监听, 只保留新监听 (从 this.discussion 构造). LESS 19 段
//        .DiscussionHero-title/.item-tags { display: none !important } 已 CSS 隐藏 hero 容器内
//        残留 title + tags 节点 (r.19 CSS 限定 .DiscussionHero 内), 视觉无差
//     2. 新监听对象: DiscussionPage (Flarum 2.0 lazy chunk, 走 vendor extend 字符串路径
//        `flarum/forum/components/DiscussionPage` → flarum.reg.onLoad 异步注册, 见 ziven-core
//        r.18c safeExtend SOP 沉淀)
//     3. 新函数 insertTitleAndTagsFromDiscussion: 从 this.discussion 直接构造 h1 + ul.item-tags
//        wrap 成 PostHeroTitle/PostHeroTags 插入 Post-main (绕开 DOM querySelector 依赖)
//     4. 时序兜底: 500ms setTimeout (PostStream 异步加载, 第一次 DiscussionPage.onupdate 时
//        Post-main 可能还没渲染, 500ms 后 PostStream 通常加载完, 再跑一次)
//     5. 函数体保留: moveTitleToPostMain/moveTagsToPostMain 不动 (辉哥 SOP), 作为 ziven-core
//        撤销 r.18x 时的备用 fallback (恢复旧监听立即可用)
//
// r.19.4 (辉哥 9/18 13:00 拍板, 返工 r.19.3 后) 修 tags 样式丢:
//   - 真因 (Mavis 9/18 12:55 调查): r.19.3 撤旧 4 行 DiscussionHero 监听 + 新函数自己构造 plain
//     `<a>` textContent, 没 import vendor tagsLabel() helper 也没用 mithril render. 结果:
//     tags 节点存在但没 vendor .TagLabel 样式 (蓝胶囊 + 圆角 + tag.color() 颜色 +
//     textContrastClass 文字色 + Link href + hover). 辉哥 9/18 13:00 d/13 亲测 FAIL.
//   - 修法:
//     1. 恢复旧 4 行 DiscussionHero 监听 — 有图情况 vendor DiscussionHero 内部含 vendor
//        flarum-tags 扩展注入的 .item-tags (含 vendor .TagLabel), 旧监听 detach + wrap vendor DOM
//        到 Post-main 内 PostHeroTags, 保留完整 vendor .TagLabel 样式
//     2. 改 insertTitleAndTagsFromDiscussion tags 段: 改用 vendor tagsLabel() helper +
//        mithril render 替代 plain `<a>`. vendor tagsLabel 是 lazy chunk, 走动态 import()
//        异步加载 + module-scope 缓存 (ziven-core r.18c safeExtend SOP 沉淀).
//        加载失败 fallback 到 plain <a> (r.19.3 行为, 视觉不完美但保证 tags 不丢)
//     3. 双轨并存 + 去重: 旧监听 (有图情况搬 vendor DOM) + 新函数 (无图情况构造 vendor DOM 或
//        fallback). 两边都检查 Post-main 已有 .PostHeroTags 就跳过, async 等待 race 二次检查.
//
// r.20 (辉哥 9/18 19:28 拍板) 移动端 PostHeroTags 行右侧加 [关注 + 收藏] 单图标按钮:
//   - 设计参考: mockup-post-hero-actions.html (H3 锚点 aeb40bb)
//   - 关注: 单按钮 ⭐ (无 caret, 无 SplitDropdown 双段), 点击弹 3 选项 Dropdown 菜单
//     (Not Following / Following / Ignoring), 模仿 vendor SubscriptionMenu.tsx 行为 +
//     vendor DetailedDropdownItem 风格, 但不用 SplitDropdown (辉哥强调单按钮)
//     状态 3:
//       - null: ☆ far fa-star + 灰 #9CA3AF
//       - follow: ⭐ fas fa-star + 黄 #F59E0B (active)
//       - ignore: 🚫 far fa-eye-slash + 灰 #6B7280 (半透明, opacity 0.7)
//     onclick: discussion.save({ subscription: states[subscription].save })
//   - 收藏: 单按钮 🔖 (vendor fof/bookmarks toggle, 复用 BookmarkButton 逻辑)
//     状态 2:
//       - false: 📑 far fa-bookmark + 灰
//       - true: 🔖 fas fa-bookmark + 深蓝 #1E40AF (active)
//     onclick: discussion.save({ bookmarked: !wasBookmarked })
//   - 仅移动端 (@media max-width: 991.98px) 渲染, 桌面端完全不变 (辉哥强调两次)
//   - 桌面端走 vendor r.16 关注按钮 (Post-header 行右侧, .Button--follow-user) + vendor
//     fof-bookmarks (Post-actions 内), r.20 不影响桌面端流程
//   - 未登录不渲染 (依赖 app.session.user, 跟 vendor SubscriptionMenu 一致)
//   - 新函数: addPostHeroActionsToPostHeroTags(postHeroTags, discussion)
//     在 insertTitleAndTagsFromDiscussion 末尾调用 (PostHeroTags 创建完后立即挂 PostHeroActions)
//
// 回滚锚 H1 tag (v0.2.5f.i = a510b5b). 走不通立刻 git checkout H1.

import app from 'flarum/common/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import DetailedDropdownItem from 'flarum/common/components/DetailedDropdownItem';
import Icon from 'flarum/common/components/Icon';
import CommentPost from 'flarum/forum/components/CommentPost';
import Discussion from 'flarum/common/models/Discussion';

// r.19.4 (辉哥 9/18 13:00 拍板): vendor tagsLabel() helper.
// 直接 `flarum.reg.asyncModuleImport('flarum/tags/common/helpers/tagsLabel')` 会被 flarum-webpack-config externals
// (L130 `^flarum/(.+)$` regex) 编译成 `flarum.reg.get('core', 'tags/common/helpers/tagsLabel')`,
// namespace 错配 (vendor flarum-tags 在 'flarum-tags' namespace 不是 'core') → 永远 undefined.
// 改走 vendor `flarum.reg.get('flarum-tags', 'common/helpers/tagsLabel')` 同步拿 vendor tagsLabel
// function (vendor flarum-tags 在 initializers 时已经 flarum.reg.add 了). 同步拿的好处: 没有
// async race + 不用 MutationObserver/重试. 缺点: 必须在 vendor flarum-tags init 之后跑 — 但
// ziven-theme-aura 的 modifyDiscussionHero() 在 `app.initializers.add('ziiven-theme-aura', ...)`
// 内, vendor flarum-tags 在更早的 initializers add, 所以这里同步拿一定可用.
//
// mithril 也不在 flarum-webpack-config externals (只能 externals `flarum/*`), ziven-theme-aura
// 没装 mithril module. 走 vendor 暴露的全局 window.m (Flarum 2.0 vendor 把 mithril 挂在 window.m,
// 所有 extension 都能用). 函数体内拿 (initializer 跑时 window.m 已加载).
//
// 兜底: 如果 vendor flarum-tags 没安装 (tagsLabel 不存在), fall back 到 plain `<a>` 构造
// (r.19.3 行为, 视觉不完美但保证 tags 不丢).
function getTagsLabel() {
  try {
    return flarum.reg.get('flarum-tags', 'common/helpers/tagsLabel') || null;
  } catch (e) {
    console.warn('[ziven-theme-aura r.19.4] tagsLabel load failed, fallback to plain <a>:', e && e.message);
    return null;
  }
}

/**
 * 检测移动端 (跟 less @media (max-width: 991.98px) 一致).
 * SSR HTML 渲染时 window 存在 (Flarum 客户端 SPA), matchMedia 同步返回 bool.
 *   - 桌面浏览器窗口缩到 < 992px: isMobile() === true → 触发移动端样式
 *   - 移动端横屏/真桌面: 取决于 viewport
 */
function isMobile() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(max-width: 991.98px)').matches;
}

/**
 * r.19 / r.19.1 / r.19.2 时代: 把 .DiscussionHero-title 从 hero 区 detach, wrap 成 .PostHeroTitle 卡片,
 * 插入到 PostStream 第一个 Post 的 .Post-header 前 (即 .Post-main 第一个子元素,
 * 辉哥 9/17 09:43 拍板: 标题放在最上面, header/用户信息在下面).
 *
 * r.19 辉哥 9/17 10:38 拍板: 桌面端 hero title 也隐藏 (跟移动端一致), 所以两端都跑.
 *
 * 多次调用幂等: 已 wrap + 已插入则跳过.
 * 调用时机 (历史): DiscussionHero oncreate + onupdate (每次 redraw 后).
 *
 * r.19.3 (辉哥 9/18 12:21 拍板): UNUSED. ziven-core r.18x 后无图情况 DiscussionHero 不渲染,
 * 此函数依赖的 .DiscussionHero-title DOM 节点不存在 → 函数无效. 新逻辑改监听 DiscussionPage
 * + insertTitleAndTagsFromDiscussion 从 this.discussion 构造 (见 export default).
 * 函数体保留作为 ziven-core 撤销 r.18x 时的备用 fallback.
 */
function moveTitleToPostMain() {
  const titleEl = document.querySelector('.DiscussionHero-title');
  if (!titleEl) return;

  // 找到 PostStream 第一个 Post 的 Post-header
  const firstPostHeader = document.querySelector('.PostStream .Post:first-child .Post-header, .PostStream-item:first-child .Post-header');
  if (!firstPostHeader) return;

  // title 已经在 amber wrap 里: 跳过 wrap, 检查是否已插入正确位置
  let wrapper = titleEl.parentElement;
  if (wrapper && wrapper.classList.contains('PostHeroTitle')) {
    // wrap 已存在, 检查是否已在 firstPostHeader 前
    if (wrapper.parentElement === firstPostHeader.parentElement) {
      // 已经在 .Post-main 里, 但位置不一定对. 检查是否 previousSibling
      // insertBefore 调用本身幂等 (wrapper 已在正确位置 → 移动回相同位置 noop)
      if (firstPostHeader.previousSibling !== wrapper) {
        // 调整位置到 Post-header 紧前 (标题放最上面)
        firstPostHeader.parentElement.insertBefore(wrapper, firstPostHeader);
      }
      return;
    }
    // wrap 在其他位置 (例如 .DiscussionHero 内部), detach 后插入
    firstPostHeader.parentElement.insertBefore(wrapper, firstPostHeader);
    return;
  }

  // title 还没 wrap: 创建 .PostHeroTitle wrap
  wrapper = document.createElement('div');
  wrapper.className = 'PostHeroTitle';
  // 把 titleEl 移到 wrapper 内 (从原 parent 抽出)
  titleEl.parentNode.insertBefore(wrapper, titleEl);
  wrapper.appendChild(titleEl);

  // 把 wrapper 插入到 .Post-header 前 (即 .Post-main 内, Post-header 紧前, 标题最上面)
  firstPostHeader.parentElement.insertBefore(wrapper, firstPostHeader);
}

/**
 * r.19 新增 (辉哥 9/17 10:38 拍板): 把 .DiscussionHero .item-tags (vendor flarum-tags 扩展
 * extend DiscussionHero.items() 注入的 ul) 从 hero 区 detach, wrap 成 .PostHeroTags,
 * 插到 Post-main 内的 PostHeroTitle 紧**后** (= Post-header 紧**前**).
 * 无 PostHeroTitle 时插到 Post-header 紧前 (兜底).
 *
 * r.19 bug fix (辉哥 9/17 10:48): Post-main 顺序 = [PostHeroTitle, PostHeroTags, Post-header].
 * 辉哥原话: "tag 在 PostHeroTitle 和 Post-header 之间".
 *   注: 辉哥 SOP 10:48 描述跟给的代码逻辑反 (代码说"紧前" 实指"紧后"), 按 V 测视觉
 *   "tags 在标题下面" + "应该是 [Title, Tags, Header]" 实现 — wrap.nextSibling === firstPostHeader
 *   (即 wrap.previousSibling === postHeroTitle, wrap 在 Title 紧后, Header 紧前).
 *
 * 两端都跑 (桌面端 + 移动端一致).
 *
 * 多次调用幂等: 已 wrap + 已插入则跳过.
 * 调用时机 (历史): DiscussionHero oncreate + onupdate (每次 redraw 后).
 *
 * r.19.3 (辉哥 9/18 12:21 拍板): UNUSED. 跟 moveTitleToPostMain 同理 (ziven-core r.18x
 * 让 hero() 在无图时返 null, vendor DiscussionHero 不渲染, .DiscussionHero .item-tags
 * DOM 不存在 → 函数无效). 新逻辑改用 insertTitleAndTagsFromDiscussion 从 this.discussion.tags()
 * 构造新 ul.item-tags wrap (见 export default). 函数体保留作为备用 fallback.
 */
function moveTagsToPostMain() {
  const itemTagsLi = document.querySelector('.DiscussionHero .item-tags');
  if (!itemTagsLi) return;
  const firstPostHeader = document.querySelector('.PostStream .Post:first-child .Post-header, .PostStream-item:first-child .Post-header');
  if (!firstPostHeader) return;

  // 计算插入位置:
  //   - 有 PostHeroTitle: wrap 插到 postHeroTitle.nextSibling 紧前 = postHeroTitle 紧后
  //     结果 Post-main DOM = [PostHeroTitle, wrap, Post-header]
  //   - 兜底 (无 PostHeroTitle): wrap 插到 firstPostHeader 紧前
  // r.19.1 bug fix note (辉哥 9/17 10:48): 即使 JS 把 wrap 插到 PostHeroTitle 紧后,
  //   mithril 在 onupdate 后会 revert wrap 到 Post-main 顶端 (idx 0). CSS order 强制排序.
  const postMain = firstPostHeader.parentElement;
  const postHeroTitle = postMain.querySelector(':scope > .PostHeroTitle');
  const beforeRef = postHeroTitle ? postHeroTitle.nextSibling : firstPostHeader;

  // tags 已经在 PostHeroTags wrap 里: 跳过 wrap, 检查是否已插入正确位置
  let wrapper = itemTagsLi.parentElement;
  if (wrapper && wrapper.classList.contains('PostHeroTags')) {
    if (wrapper.parentElement === postMain) {
      // 已在 Post-main 里, 检查是否在 beforeRef 紧前
      if (wrapper !== beforeRef) {
        postMain.insertBefore(wrapper, beforeRef);
      }
      return;
    }
    // wrap 在其他位置 (例如 .DiscussionHero 内部), 移到 Post-main 内正确位置
    postMain.insertBefore(wrapper, beforeRef);
    return;
  }

  // tags 还没 wrap: 创建 .PostHeroTags wrap
  wrapper = document.createElement('div');
  wrapper.className = 'PostHeroTags';
  itemTagsLi.parentNode.insertBefore(wrapper, itemTagsLi);
  wrapper.appendChild(itemTagsLi);

  // 把 wrapper 插入到 postHeroTitle 紧后 (或 firstPostHeader 紧前兜底)
  postMain.insertBefore(wrapper, beforeRef);
}

/**
 * r.19.3 新增 (辉哥 9/18 12:21 拍板方案 1 + Mavis 临场加新函数):
 * 修 ziven-core r.18x (commit 0b0ed97) 让 hero() 在无头图情况下返 null 后,
 * Post-main 内没 PostHeroTitle / PostHeroTags → 标题/tags 都丢的 bug.
 *
 * 根因:
 *   - r.19 / r.19.1 / r.19.2 监听 DiscussionHero.prototype.oncreate/onupdate 搬
 *     .DiscussionHero-title + .DiscussionHero .item-tags, 但 ziven-core r.18x 让
 *     hero() 在 heroImageUrl 不存在时返 null → vendor DiscussionHero 整个不渲染
 *     → .DiscussionHero-title/.item-tags DOM 节点根本不存在 → moveTitleToPostMain
 *     /moveTagsToPostMain 函数体里 document.querySelector 查不到 → return →
 *     Post-main 内没 PostHeroTitle/PostHeroTags → 标题/tags 丢 (辉哥 9/18 11:19 d/13 反馈).
 *   - 有图情况 (ziven-core DiscussionPageHero 内部含 vendor DiscussionHero) 仍 work,
 *     旧 DiscussionHero 监听保持 (行为不变 r.19.2 V 测 PASS).
 *
 * 修法:
 *   - 新加本函数, 从 this.discussion 直接构造 h1 标题 + ul.item-tags,
 *     wrap 成 .PostHeroTitle + .PostHeroTags 插入 Post-main (绕开 DOM querySelector 依赖,
 *     不依赖 vendor DiscussionHero 渲染).
 *   - 监听 DiscussionPage.oncreate + onupdate, 配合 500ms setTimeout 兜底 Post-main
 *     异步渲染 (PostStreamState 异步 load, 第一次 onupdate 时 Post-main 可能还没渲染).
 *   - moveTitleToPostMain / moveTagsToPostMain 函数体不动 (辉哥 SOP), 旧 DiscussionHero
 *     监听保留兜底有图情况.
 *
 * 幂等: Post-main 已有 .PostHeroTitle / .PostHeroTags 跳过构造, 多次调用安全.
 * 调用时机: DiscussionPage.oncreate + onupdate + 500ms setTimeout.
 */
/**
 * r.19.4 (辉哥 9/18 13:00 拍板): 用 vendor tagsLabel() helper + window.m.render.
 *
 * 与 r.19.3 区别:
 *   - r.19.3 自己构造 plain `<a>` textContent, 没 vendor TagLabel 样式 (蓝胶囊 + 颜色 + hover).
 *   - r.19.4 用 vendor `tagsLabel(tags, { link: true })` → vendor `<span class="TagsLabel">`
 *     包裹 `<TagLabel>` 子组件, 含 vendor .TagLabel CSS (蓝胶囊 + 圆角 + tag.color() 颜色 +
 *     textContrastClass 自动文字色 + Link 组件 href 路由 + hover + tag.icon()).
 *   - vendor tagsLabel 通过 `flarum.reg.get('flarum-tags', 'common/helpers/tagsLabel')` 同步拿
 *     (vendor flarum-tags initializers 已注册). mithril 通过 `window.m` 拿 (vendor 暴露全局).
 *   - 加载失败 fallback 到 plain `<a>` (r.19.3 行为, 视觉不完美但保证 tags 不丢).
 *   - 标题部分: 跟 r.19.3 一致, vendor DiscussionHero-title CSS 样式本来就有, h1 已应用.
 *
 * 幂等: 已存在 .PostHeroTitle / .PostHeroTags 跳过构造 (避免与旧监听 moveTagsToPostMain 重复搬 vendor DOM).
 */
function insertTitleAndTagsFromDiscussion() {
  if (!this || !this.discussion) return;
  const postMain = document.querySelector('.PostStream .Post:first-child .Post-main, .PostStream-item:first-child .Post-main');
  if (!postMain) return; // Post-main 还没渲染, 等下次 onupdate / setTimeout 兜底

  // 1. 标题: 构造 h1.DiscussionHero-title (跟 vendor DiscussionHero.items() + 标题同款 className),
  //    包 .PostHeroTitle. 已有则跳过 (幂等).
  let postHeroTitle = postMain.querySelector(':scope > .PostHeroTitle');
  if (!postHeroTitle) {
    postHeroTitle = document.createElement('div');
    postHeroTitle.className = 'PostHeroTitle';
    const h1 = document.createElement('h1');
    h1.className = 'DiscussionHero-title';
    h1.textContent = String(this.discussion.title() || '');
    postHeroTitle.appendChild(h1);
    const firstPostHeader = postMain.querySelector(':scope > .Post-header');
    if (firstPostHeader) {
      postMain.insertBefore(postHeroTitle, firstPostHeader);
    } else {
      postMain.insertBefore(postHeroTitle, postMain.firstChild);
    }
  }

  // 2. tags: 用 vendor tagsLabel() helper + window.m.render → div.PostHeroTags 内含 vendor .TagLabel 节点.
  //    已有则跳过 (幂等 — 旧监听 moveTagsToPostMain 可能已搬 vendor DOM 过来).
  if (postMain.querySelector(':scope > .PostHeroTags')) return;
  const tags = this.discussion.tags && this.discussion.tags();
  if (!tags || tags.length === 0) return; // 没 tags 不渲染 (跟 vendor 行为一致)

  const tagsLabel = getTagsLabel();
  if (!tagsLabel) {
    // fallback: plain <a> (r.19.3 行为, 视觉不完美但保证 tags 不丢)
    const postHeroTags = document.createElement('div');
    postHeroTags.className = 'PostHeroTags';
    const ul = document.createElement('ul');
    ul.className = 'DiscussionHero-items item-tags';
    tags.forEach(tag => {
      const li = document.createElement('li');
      li.className = 'item-tag';
      const a = document.createElement('a');
      a.href = app.route.tag(tag);
      a.textContent = tag.name();
      li.appendChild(a);
      ul.appendChild(li);
    });
    postHeroTags.appendChild(ul);
    insertPostHeroTagsIntoPostMain(postMain, postHeroTitle, postHeroTags);
    return;
  }

  // vendor tagsLabel 路径: tagsLabel(tags, { link: true }) 返回 vnode <span class="TagsLabel">
  // 包所有 tag children: 每个 tag 是 <a class="TagLabel colored text-contrast--xxx"
  // style="--tag-bg: <color>" title="<description>" href="/t/<slug>"> 含 TagLabel-text >
  // TagLabel-icon + TagLabel-name.
  // mithril render 整个 vnode 到 PostHeroTags div, div 用 .PostHeroTags class 给 LESS 19 段
  // amber 卡片样式.
  const postHeroTags = document.createElement('div');
  postHeroTags.className = 'PostHeroTags';
  window.m.render(postHeroTags, tagsLabel(tags, {
    link: true
  }));
  insertPostHeroTagsIntoPostMain(postMain, postHeroTitle, postHeroTags);

  // r.20 (辉哥 9/18 19:28 拍板): 移动端 PostHeroTags 行右侧加 [关注 + 收藏] 单图标按钮.
  // 桌面端完全不变 (addPostHeroActionsToPostHeroTags 内部 isMobile() 检查).
  addPostHeroActionsToPostHeroTags(postHeroTags, this.discussion);
}

/**
 * 把 PostHeroTags 插到 Post-main (PostHeroTitle 紧后, Post-header 紧前).
 * 提取出来避免 async 函数重复.
 */
function insertPostHeroTagsIntoPostMain(postMain, postHeroTitle, postHeroTags) {
  const beforeRef = postHeroTitle.nextSibling;
  if (beforeRef) {
    postMain.insertBefore(postHeroTags, beforeRef);
  } else {
    postMain.appendChild(postHeroTags);
  }
}

/**
 * r.20 新增 (辉哥 9/18 19:28 拍板):
 * 移动端 PostHeroTags 行右侧加 [关注 + 收藏] 单图标按钮 (桌面端完全不变).
 *
 * 设计参考: mockup-post-hero-actions.html (H3 锚点 aeb40bb)
 *
 * 实现细节:
 *   - 关注按钮: 单按钮 (无 caret, 无 SplitDropdown), 点击弹 3 选项 Dropdown 菜单
 *     (Not Following / Following / Ignoring), 模仿 vendor SubscriptionMenu.tsx 行为
 *     + vendor DetailedDropdownItem 风格, 但不用 SplitDropdown (辉哥强调单按钮)
 *   - 收藏按钮: 单 Button, 复用 vendor BookmarkButton 逻辑 (`subject.save({ bookmarked: !bookmarked })`)
 *   - 仅移动端 (@media max-width: 991.98px) 渲染, 桌面端完全不渲染 (辉哥强调两次)
 *   - SSR (window undefined): 默认 desktop 不渲染 (保守)
 *
 * 复用 vendor:
 *   - vendor flarum-subscriptions: Discussion model 已有 subscription() 属性
 *   - vendor fof-bookmarks: Discussion/Post model 都有 bookmarked() 属性 + save({ bookmarked })
 *
 * 状态 3 关注:
 *   - null: ☆ far fa-star + 灰 #9CA3AF
 *   - follow: ⭐ fas fa-star + 黄 #F59E0B (active)
 *   - ignore: 🚫 far fa-eye-slash + 灰 #6B7280 (半透明)
 *
 * 状态 2 收藏:
 *   - false: 📑 far fa-bookmark + 灰
 *   - true: 🔖 fas fa-bookmark + 深蓝 #1E40AF (active)
 *
 * 注入位置: PostHeroTags div 内, tags <ul> 后 (跟在 tagsLabel vnode 后面).
 *
 * 幂等: PostHeroTags 已有 .PostHeroActions 跳过.
 */
function addPostHeroActionsToPostHeroTags(postHeroTags, discussion) {
  if (!postHeroTags || !discussion) return;

  // 仅移动端 (辉哥强调两次桌面端不变, 跟 r.16 关注按钮 isMobile() 检查一致)
  if (!isMobile()) return;

  // 未登录不渲染 (跟 vendor SubscriptionMenu.tsx 一致, 内部依赖 app.session.user)
  if (!app.session.user) return;

  // 计算 subscription 状态对应的 icon + className 修饰符 (辉哥 9/19 9:52 拍板 灰/黄/红)
  // r.20g fix: 用 discussion.data.attributes.subscription 直接读 API payload (避免 vendor Model
  // getter 在 Flarum 2.x 模型 wrapper 里 this binding 出错: 'Cannot read properties of undefined
  // (reading attribute)', 直接读 payload 是 robust 兜底)
  const subscription = discussion.data && discussion.data.attributes && discussion.data.attributes.subscription;
  let iconName, iconClass;
  if (subscription === 'follow') {
    iconName = 'fas fa-star';
    iconClass = 'PostHeroActions-subscription--followed';
  } else if (subscription === 'ignore') {
    iconName = 'far fa-eye-slash';
    iconClass = 'PostHeroActions-subscription--ignored';
  } else {
    iconName = 'far fa-star';
    iconClass = '';
  }

  // r.20g (辉哥 9/19 9:52 拍板): 检测 existing PostHeroActions, 存在则 update subscription button
  // 状态 (icon + className), 不重建 (r.20f bug: 整个 return 跳过, mithril redraw 后图标/颜色不变).
  // vendor 原生 click → discussion.save → mithril redraw → oncreate/onupdate 重跑此函数 →
  // 检测到 PostHeroActions 已存在 → 只更新 subscription button 状态 (icon + className).
  //
  // r.20i (辉哥 9/19 10:59): 同时 update bookmark button 状态 (icon + className + title),
  // 修 r.20h 回归 — 原 update 分支 (L451-464) 只处理 subscription button, 收藏 🔖 save 后
  // mithril redraw 触发此函数, bookmark 按钮视觉不刷新 (apiBookmarked 已变). 改成 update
  // 分支也处理 bookmark button, 跟 subscription 同步刷新.
  let postHeroActions = postHeroTags.querySelector(':scope > .PostHeroActions');
  if (postHeroActions) {
    const existingSubscriptionBtn = postHeroActions.querySelector('.PostHeroActions-subscription');
    if (existingSubscriptionBtn) {
      const iconEl = existingSubscriptionBtn.querySelector('i');
      if (iconEl) iconEl.className = "".concat(iconName, " Button-icon");
      existingSubscriptionBtn.className = "PostHeroActions-subscription ".concat(iconClass).trim();
    }

    // r.20i: 同步 update bookmark button. 跟 subscription button 一样, 检测 postHeroActions 已
    // 存在时, 不重建, 只更新 bookmark 视觉. 重读 discussion.bookmarked() (Flarum 2.x Model
    // 原生 prototype 方法, 跟 r.20g subscription 这边走 data.attributes 的不同 — bookmarked()
    // 是 vendor 方法, 在 Flarum 2.x 模型 wrapper this binding 不出错, 可直接调).
    const existingBookmarkBtn = postHeroActions.querySelector('.PostHeroActions-bookmark');
    if (existingBookmarkBtn) {
      const bookmarkedNow = !!(discussion.bookmarked && discussion.bookmarked());
      existingBookmarkBtn.className = "Button PostHeroActions-bookmark ".concat(bookmarkedNow ? 'PostHeroActions-bookmark--active' : '').trim();
      existingBookmarkBtn.setAttribute('title', bookmarkedNow ? '已收藏' : '收藏');
      const bookmarkIconEl = existingBookmarkBtn.querySelector('i');
      if (bookmarkIconEl) bookmarkIconEl.className = "".concat(bookmarkedNow ? 'fas' : 'far', " fa-bookmark Button-icon");
      // 注意: 不重置 dataset.loading — 留给 onclick handler 自己 setTimeout 1500 后清.
    }
    return;
  }

  // r.20g: 首次创建 PostHeroActions (PostHeroTags 首次挂载时)
  postHeroActions = document.createElement('div');
  postHeroActions.className = 'PostHeroActions';
  const subscriptionButton = document.createElement('button');
  subscriptionButton.type = 'button';
  subscriptionButton.className = "PostHeroActions-subscription ".concat(iconClass).trim();
  subscriptionButton.setAttribute('aria-label', '订阅');
  subscriptionButton.title = '订阅';
  subscriptionButton.innerHTML = "<i class=\"".concat(iconName, " Button-icon\"></i>");

  // r.20f (辉哥 9/19 9:36 拍板): 模拟点击 vendor SplitDropdown caret, 让 vendor 原生 Dropdown 弹出
  // vendor flarum/subscriptions SubscriptionMenu.tsx 用 SplitDropdown (L18-59),
  // .Dropdown-toggle.Button.Button--icon + data-toggle="dropdown" + Icon fa-caret-down.
  // vendor Dropdown.tsx L127: this.$().Dropdown-toggle.dropdown('toggle') (Bootstrap 4 触发).
  // 任何原生 .click() 都能触发 Bootstrap dropdown 自动 toggle.
  subscriptionButton.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    const vendorCaret = document.querySelector('.SubscriptionMenu .Dropdown-toggle');
    if (!vendorCaret) {
      console.warn('[ziven-theme-aura r.20f] vendor SubscriptionMenu caret not found (未登录或 vendor 没渲染?)');
      return;
    }
    vendorCaret.click();
  });

  // === 收藏按钮 (r.20i: 复用 vendor BookmarkButton 完整流程 — onclick 模拟 vendor .Button--bookmark click) ===
  // 辉哥 9/19 10:59 拍板 r.20i 方向: tags 行 🔖 onclick → 模拟 vendor 顶部 banner 收藏按钮 click,
  //   让 vendor BookmarkButton 自己 toggle + `subject.save()` + m.redraw(), tags 行 🔖 通过 r.20h
  //   双钩 (Discussion.save hook + m.redraw wrapper) 自动联动实时刷新.
  // 跟 r.20f 订阅按钮的 `subscriptionButton.onclick → vendorCaret.click()` 一模一样的模式.
  //
  // 辉哥 config 实际: `fof-bookmarks.postButtonPosition='menu'` + `fof-bookmarks.independentButton=true`
  //   → vendor 在 DiscussionPage sidebar 渲染 `.Button--bookmark`, subject={discussion}. 在 mobile
  //   视口 <992px, sidebar .Page-sidebar { display:none } 把整个 sidebar 折叠不可见, 但 .Button--bookmark
  //   仍在 DOM. JS-level .click() 触发 vendor onclick 不受 display:none 影响 (跟 r.20f subscription
  //   caret 同款), vendor BookmarkButton.toggle() 走 subject.save → API PATCH → m.redraw(), r.20h
  //   双钩监控 Discussion.save.then (subscription OR bookmarked) + m.redraw wrapper 监全局 redraw,
  //   自动触发 addPostHeroActionsToPostHeroTags update 模式, 重读 `discussion.bookmarked()`
  //   实时更新 tags 行 🔖 icon + className.
  //
  // 多层兜底 (防御 vendor config 变更导致 .Button--bookmark 不存在):
  //   1. .Button--bookmark (independentButton sidebar, 辉哥当前 config)
  //   2. .Button--bookmark-post (postButtonPosition='header')
  //   3. 兜底走原 direct `discussion.save({bookmarked})` (r.20f 之前模式, 仍 work)
  const isBookmarked = discussion.bookmarked && discussion.bookmarked();
  const bookmarkButton = document.createElement('button');
  bookmarkButton.type = 'button';
  bookmarkButton.className = "Button PostHeroActions-bookmark ".concat(isBookmarked ? 'PostHeroActions-bookmark--active' : '');
  bookmarkButton.setAttribute('aria-label', '收藏');
  bookmarkButton.title = isBookmarked ? '已收藏' : '收藏';
  bookmarkButton.innerHTML = "<i class=\"".concat(isBookmarked ? 'fas' : 'far', " fa-bookmark Button-icon\"></i>");
  bookmarkButton.addEventListener('click', e => {
    e.stopPropagation();
    if (bookmarkButton.dataset.loading === '1') return;
    bookmarkButton.dataset.loading = '1';
    try {
      // 优先 .Button--bookmark (辉哥当前 config 下, 在 DiscussionPage.sidebarItems,
      // mobile 视口 sidebar display:none 但 DOM 仍在 — JS .click() 不受影响)
      // 兜底 .Button--bookmark-post (vendor addPostControls postButtonPosition='header' 时)
      const vendorBtn = document.querySelector('.Button--bookmark') || document.querySelector('.Button--bookmark-post');
      if (vendorBtn) {
        // vendor BookmarkButton.toggle() 内部: saving flag guard + subject.save({bookmarked}) +
        // .then(() => m.redraw()). vendor saving flag 防双击, 我们 dataset.loading 同保险.
        vendorBtn.click();
        // 失败兜底: 如果 vendor 自己翻 (极少 — saving flag 可能吃 save promise reject), 
        // 我们重置 dataset
        setTimeout(() => {
          bookmarkButton.dataset.loading = '0';
        }, 1500);
      } else {
        // vendor 按钮都不存在 (config 边缘情况, 兜底走 direct save)
        console.warn('[ziven-theme-aura r.20i] vendor .Button--bookmark + .Button--bookmark-post not found, fallback to direct discussion.save');
        discussion.save({
          bookmarked: !isBookmarked
        }).then(() => {
          bookmarkButton.dataset.loading = '0';
        }).catch(() => {
          bookmarkButton.dataset.loading = '0';
        });
      }
    } catch (err) {
      bookmarkButton.dataset.loading = '0';
      console.warn('[ziven-theme-aura r.20i] vendor .click() error, reset loading:', err && err.message);
    }
  });
  postHeroActions.appendChild(subscriptionButton);
  postHeroActions.appendChild(bookmarkButton);

  // 插入到 PostHeroTags 末尾 (tags ul 后)
  postHeroTags.appendChild(postHeroActions);
}
export default function modifyDiscussionHero() {
  // === r.19.4 (辉哥 9/18 13:00 拍板, 返工 r.19.3 后): 恢复 4 行旧 DiscussionHero 监听
  //     + 改 insertTitleAndTagsFromDiscussion 用 vendor tagsLabel() helper ===
  //
  // 根因 (Mavis 9/18 12:55 调查):
  //   - r.19.3 撤了旧 4 行 DiscussionHero 监听, 同时新函数自己构造 plain `<a>` textContent,
  //     没 import vendor tagsLabel() helper 也没用 mithril render.
  //   - 结果: tags 节点存在但没有 vendor .TagLabel 样式 (蓝胶囊 + 圆角 + tag.color() 颜色
  //     + textContrastClass 文字色 + Link href 路由 + hover 效果), 视觉裸 `<a>` text.
  //   - 辉哥 9/18 13:00 d/13 亲测 FAIL: tags 看着是 plain text, 没蓝胶囊也没 tag 颜色.
  //
  // r.19.4 改法:
  //   - 恢复旧 4 行 DiscussionHero 监听 (moveTitleToPostMain + moveTagsToPostMain):
  //     有图情况 (ziven-core DiscussionPageHero 内部含 vendor DiscussionHero, vendor
  //     flarum-tags 扩展 addTagLabels.js L35-41 在 DiscussionHero.items() 用 tagsLabel()
  //     helper 渲染含 .TagLabel + tag.color() 颜色的 vnode), 旧监听 detach + wrap vendor DOM
  //     到 Post-main 内 PostHeroTags, 保留完整 vendor .TagLabel 样式.
  //   - 改 insertTitleAndTagsFromDiscussion: tags 段改用 vendor tagsLabel() helper + 
  //     mithril render 替代 plain `<a>`. vendor tagsLabel 是 lazy chunk, 走动态 import() 
  //     异步加载 (ziven-core r.18c safeExtend SOP 沉淀). 加载失败 fallback 到 plain <a>.
  //   - 双轨并存: 旧监听 (有图情况搬 vendor DOM) + 新函数 (无图情况构造 vendor DOM 或 fallback).
  //     去重: 两边都检查 Post-main 已有 .PostHeroTags 就跳过, 二次检查覆盖 async 等待 race.
  //
  // 标题部分 r.19.3 不变: vendor .DiscussionHero-title CSS 样式本来就有, h1 已应用.

  // === r.19.4 取消旧 4 行 DiscussionHero 监听 (避免双轨并存导致 d/430 有图情况 Post-main
  //     出现 2 个 PostHeroTitle + PostHeroTags 实测 bug) ===
  // r.19.3 撤了旧 4 行. r.19.4 恢复旧 4 行 + 新函数构造 vendor TagLabel, 双轨并存导致 d/430
  // 有图情况 (ziven-core DiscussionPageHero 内部含 vendor DiscussionHero, .DiscussionHero-items
  // 含 vendor .TagLabel) moveTagsToPostMain 搬 vendor DOM 到 Post-main + insertTitleAndTagsFromDiscussion
  // 同步构造另一个 PostHeroTags → Post-main 出现 2 个 wrapper div, 视觉重复.
  //
  // 改法: 取消旧 4 行, 单一来源 = 新函数 insertTitleAndTagsFromDiscussion 从 this.discussion.tags()
  // 走 vendor tagsLabel() helper 构造 (r.19.4 关键改进: 含 vendor .TagLabel 样式). 有图情况
  // vendor DiscussionHero 内的 .item-tags (vendor TagLabel) 留在 hero 容器, LESS 19 段 CSS
  // `.DiscussionHero .item-tags { display: none !important }` 隐藏, 视觉无差.

  // === 新 3 行 DiscussionPage 监听 (r.19.3 加, r.19.4 保留) ===
  //    无图情况兜底: DiscussionHero 不渲染, 旧监听失效 → 新函数从 this.discussion 构造
  //    PostHeroTitle + PostHeroTags (含 vendor .TagLabel via tagsLabel() helper)
  //    字符串路径 'flarum/forum/components/DiscussionPage' 走 vendor extend lazy chunk
  //    异步注册 (ziven-core r.18c safeExtend SOP)
  extend('flarum/forum/components/DiscussionPage', 'oncreate', function () {
    insertTitleAndTagsFromDiscussion.call(this);
  });
  extend('flarum/forum/components/DiscussionPage', 'onupdate', function () {
    insertTitleAndTagsFromDiscussion.call(this);
  });
  // 时序兜底: 500ms setTimeout. PostStream 异步加载, 第一次 onupdate 时 Post-main 可能
  // 还没渲染; 500ms 后通常 PostStream 加载完, 再跑一次确保覆盖 (函数幂等).
  extend('flarum/forum/components/DiscussionPage', 'oncreate', function () {
    const self = this;
    setTimeout(() => insertTitleAndTagsFromDiscussion.call(self), 500);
  });

  // === r.20h (辉哥 9/19 10:09 反馈, 升级 r.20g 卡返工): 实时联动状态 ===
  // Mavis 9/19 10:14 调查真因:
  //   - 原 r.20g addPostHeroActionsToPostHeroTags update 模式 (检测 PostHeroActions 已存在时更新
  //     button 状态) 走 insertTitleAndTagsFromDiscussion L377 调用, 但该函数 L337
  //   - if (postMain.querySelector(':scope > .PostHeroTags')) return;
  //     早返回会跳过整个函数, 后续 L377 addPostHeroActions 永远不被调用. 需刷新 page 才生效.
  //   - r.20h-1 (返工 1): 单加 extend onupdate (绕过 L337 早返回), Puppeteer FAIL —
  //     DiscussionPage.onupdate 只在 page-level mithril redraw 时触发 (route change / 初始 nav),
  //     attribute-only 变化 (vendor SubscriptionMenu save) 不会触发 DiscussionPage 自身的
  //     onupdate. vendor SubscriptionMenu 的 view() 内部读 discussion.subscription() 后, mithril
  //     auto-redraw 只刷新 SubscriptionMenu 那个 vnode, 不冒泡到 DiscussionPage.onupdate.
  //   - r.20h-2 (返工 2): 包裹 mithril m.redraw wrapper. Puppeteer 测: PATCH response 后 mithril
  //     不自动调 m.redraw (async save 走 m.request().then → mithril 自动调 endComputation 的 redraw
  //     是用内嵌 m.redraw 还是另一路径, 测试 trace 显示根本没调用 wrapper). 结果: 多状态 save
  //     只有第一次触发, 后续 save button 不更新.
  //
  // 真正稳定的修法 (r.20h-3, current): 双钩机制, 双保险, 分工明确:
  //   1. extend(Discussion.prototype, 'save') — 监听 Discussion.save({subscription}). 检测到
  //      attrs.subscription 存在时给 save 返回的 Promise 链 .then() 调 m.redraw(true) (force redraw).
  //      Discussion 是 eager-loaded (跟其他 core model 一起进 main bundle), 同步可拿, 不用
  //      flarum.reg.get/onLoad 异步. extend 的 object[method] lookup 走 prototype chain 找到继承
  //      自 Model.prototype.save.
  //   2. window.m.redraw wrapper (兜底): 任何 redraw 时同步 button 状态, 其他路径触发的 redraw
  //      (其他用户操作、periodic lazy redraw) 也保证 button 跟 store 同步.
  //
  // 协作: vendor SubscriptionMenu.saveSubscription 调 discussion.save({subscription}) → Model.save
  //   → API PATCH → PATCH then 调 store.pushPayload 更新 store → 然后 chain 我们的 .then → m.redraw(true)
  //   → mithril 强制 rerender vendor SubscriptionMenu (它 view() 读 discussion.subscription()
  //   显示新状态) → 我们 m.redraw wrapper 同步调 addPostHeroActionsToPostHeroTags 走 update 分支
  //   更新 button icon + className. 两个钩确保 button 实时跟 store 一致.

  // r.20h-3 Discussion.save hook: 检测 subscription 字段 save, 完成后 force redraw.
  (function hookDiscussionSaveForSubscriptionRedraw() {
    if (typeof window === 'undefined') return;
    if (window.__zivenR20hModelHooked) return;
    if (!Discussion || !Discussion.prototype || !Discussion.prototype.save) return;
    window.__zivenR20hModelHooked = true;
    try {
      extend(Discussion.prototype, 'save', function (saveReturn, attrs) {
        if (attrs && 'subscription' in attrs && saveReturn && typeof saveReturn.then === 'function') {
          saveReturn.then(() => {
            try {
              if (window.m && typeof window.m.redraw === 'function') {
                window.m.redraw(true); // force=true
              }
            } catch (e) {
              console.warn('[ziven-theme-aura r.20h] forced redraw failed:', e && e.message);
            }
          });
        }
      });
    } catch (e) {
      console.warn('[ziven-theme-aura r.20h] Discussion.save hook install failed:', e && e.message);
      window.__zivenR20hModelHooked = false;
    }
  })();

  // r.20h m.redraw wrapper (兜底): 任何 redraw 时同步 button 状态.
  (function patchMithrilRedrawForSubscriptionButton() {
    if (typeof window === 'undefined' || !window.m || !window.m.redraw) return;
    if (window.__zivenR20hRedrawPatched) return;
    window.__zivenR20hRedrawPatched = true;
    const mithril = window.m;
    const originalRedraw = mithril.redraw.bind(mithril);

    // 保留原 redraw 上的子方法 (.sync 等) — 直接赋值会丢.
    const redrawProps = {};
    try {
      Object.getOwnPropertyNames(mithril.redraw).forEach(k => {
        if (typeof mithril.redraw[k] === 'function') {
          redrawProps[k] = mithril.redraw[k];
        }
      });
    } catch (e) {
      // 静默, 不阻塞
    }
    function wrappedRedraw() {
      const result = originalRedraw(...arguments);
      try {
        const postHeroTags = document.querySelector('.PostStream .Post:first-child .PostHeroTags, .PostStream-item:first-child .PostHeroTags');
        if (!postHeroTags) return result;
        if (!window.app || !window.app.store) return result;
        let discussionId = null;
        const match = window.location.pathname.match(/\/d\/(\d+)/);
        if (match) discussionId = match[1];
        if (!discussionId) return result;
        const discussion = window.app.store.getById('discussions', discussionId);
        if (!discussion) return result;
        addPostHeroActionsToPostHeroTags(postHeroTags, discussion);
      } catch (e) {
        // 静默吞错, 不阻塞 mithril redraw
      }
      return result;
    }
    Object.entries(redrawProps).forEach(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        fn = _ref2[1];
      wrappedRedraw[k] = fn.bind ? fn.bind(mithril) : fn;
    });
    mithril.redraw = wrappedRedraw;
  })();

  // === 2. CommentPost headerItems — 移动端: 第一个 Post 加关注按钮 ===
  // 只对第一个 Post (帖子主人, number() === 1) 显示.
  // 登录态 + 不是自己 + 可关注 (canBeFollowed() true, vendor follow-users 扩展决定).
  // 桌面端不动 — 走 vendor ianm/follow-users UserCard 流程, hero 顶部关注按钮.
  extend(CommentPost.prototype, 'headerItems', function (items) {
    if (!isMobile()) return;
    const post = this.attrs.post;
    if (!post) return;

    // 只对第一个 Post (帖子主人) 加按钮
    if (typeof post.number === 'function' && post.number() !== 1) return;
    const user = post.user();
    if (!user) return;

    // 未登录或自己: 不渲染 (避免显示关注自己的按钮)
    if (!app.session.user || typeof user.id === 'function' && app.session.user.id() === user.id()) return;

    // vendor follow-users 扩展决定是否可关注
    if (typeof user.canBeFollowed === 'function' && !user.canBeFollowed()) return;

    // 关注状态决定 icon + 文字
    const isFollowed = typeof user.followed === 'function' ? user.followed() : false;

    // 关注按钮文字 — 辉哥 9/16 14:06 拍板: 走 ziven-theme-aura 自己 i18n key, 不 hardcode 也不走 vendor
    //   (vendor ianm-follow-users zh-Hans 'change_button' 翻译 = '修改关注类型', 不直观
    //    r.16.e 用 ziiven-theme-aura.forum.follow_button / followed_button 三语 locale:
    //    en = Follow / Following, zh-Hans = 关注 / 已关注, zh-tw = 關注 / 已關注)
    const displayText = app.translator.trans(isFollowed ? 'ziiven-theme-aura.forum.followed_button' : 'ziiven-theme-aura.forum.follow_button');
    items.add('follow-user', m(Button, {
      className: isFollowed ? 'Button Button--follow-user is-followed' : 'Button Button--follow-user',
      icon: isFollowed ? 'fas fa-user-check' : 'fas fa-user-plus',
      loading: this.followLoading,
      onclick: () => {
        if (this.followLoading) return;
        this.followLoading = true;
        // vendor ianm/follow-users 字段类型 = Schema\Str (字符串), 传数字 1 直接被拒抛
        //   "follow users必须是字符串" (UserResourceFields.php L79)
        // vendor DB `bjxy_user_followers.subscription` 字段是 enum('follow', 'lurk'),
        //   传 'discussion' 不在合法值里, MySQL 静默吞成空字符串 → API response
        //   followed="", JS Boolean("")=false → 按钮永远显示 "+ 关注", toggle UI 不工作
        //   (辉哥 V 测 9/16 13:05 FAIL 根因)
        // toggle 模式 (vendor enum 合法值):
        //   - 未关注 (isFollowed false) → save { followUsers: 'follow' }
        //     vendor set(): if (!empty($subscription)) 走关注路径
        //     DB subscription = 'follow' (vendor UserCard 弹窗"关注"按钮默认级别)
        //     API response followed = 'follow', JS Boolean('follow')=true → 按钮变 "已关注"
        //   - 已关注 (isFollowed true) → save { followUsers: '' }
        //     vendor set(): if (!empty('')) 跳过, elseif ($exists) → 取消路径 (detach)
        //     API response followed = null, JS Boolean(null)=false → 按钮变回 "+ 关注"
        // 'follow' 是 vendor enum 默认值 (等同 UserCard 弹窗"关注"按钮行为)
        //   'lurk' 是静默关注 (不收通知), 不适合默认
        const nextSubscription = isFollowed ? '' : 'follow';
        user.save({
          followUsers: nextSubscription
        }).then(() => {
          this.followLoading = false;
          m.redraw();
        }).catch(() => {
          this.followLoading = false;
          m.redraw();
        });
      }
    }, displayText), -10 // priority 最低, 排最后 (在 .Post-header ul flex 布局里靠右, 配合 less 里 margin-left: auto 推到最右)
    );
  });
}